
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/rota-the-wheel",
      function () {
        return require("private-next-pages/rota-the-wheel/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/rota-the-wheel"])
      });
    }
  